export default __webpack_public_path__ + "static/media/refresh.4cf029f2.svg";